import { EventInteraction, EventInteractionContext } from '@eventbrite/ads';
import { FormattedEvent } from '@eventbrite/event-renderer';
import { getBaseTrackingContext } from '../../../../utils/tracking';

export const CITY_BROWSE_PLACEMENT_NAME = 'city_browse';

export function aggregateContext({
    events = [],
    event,
    location,
    user,
    bucketType,
    bucketIndex,
    locale,
    searchId,
}: Omit<EventInteraction, 'action'> & {
    events: FormattedEvent[];
    location: { isOnline?: boolean; placeId?: string };
    user: { id?: string; guestId?: string; sessionId?: string };
    bucketType?: string;
    bucketIndex?: number;
    locale?: string;
    searchId?: string;
}): EventInteractionContext {
    const baseTrackingContext = getBaseTrackingContext({
        event,
        events,
        userId: user.id,
        locale,
        guestId: user.guestId,
        sessionId: user.sessionId,
    });
    return {
        ...baseTrackingContext,
        place: {
            name: CITY_BROWSE_PLACEMENT_NAME,
            page: 1,
            context: {
                place_id: location.placeId,
                is_online: location.isOnline,
                search_id: searchId,
                latitude: null,
                longitude: null,
                tags: event.tags || [],
            },
            subInterface: {
                name: bucketType,
                position:
                    bucketIndex != undefined ? `${bucketIndex + 1}` : undefined,
            },
            ...baseTrackingContext.place,
        },
    };
}
